import type { GoalArenaShotOutcome } from '../../../../shared/results';

export type KeeperAction = 'center' | 'left-low' | 'left-high' | 'right-low' | 'right-high';
export type ShotProfile = {
  id: string;
  outcome: GoalArenaShotOutcome;
  target: { x: number; y: number; z: number };
  apexY: number;
  curveX: number;
  flightSeconds: number;
  keeperAction: KeeperAction;
};

export const goalShotProfiles: readonly ShotProfile[] = [
  { id: 'goal-left-high', outcome: 'goal', target: { x: -2.45, y: 2.02, z: -10.25 }, apexY: 3.65, curveX: -0.35, flightSeconds: 0.92, keeperAction: 'left-high' },
  { id: 'goal-right-low', outcome: 'goal', target: { x: 2.65, y: 0.62, z: -10.25 }, apexY: 2.15, curveX: 0.24, flightSeconds: 0.78, keeperAction: 'right-low' },
  { id: 'goal-left-low', outcome: 'goal', target: { x: -2.7, y: 0.56, z: -10.25 }, apexY: 2.05, curveX: -0.2, flightSeconds: 0.8, keeperAction: 'left-low' },
  { id: 'goal-right-high', outcome: 'goal', target: { x: 2.42, y: 2.08, z: -10.25 }, apexY: 3.75, curveX: 0.38, flightSeconds: 0.94, keeperAction: 'right-high' },
  { id: 'goal-center-power', outcome: 'goal', target: { x: 0.25, y: 1.75, z: -10.25 }, apexY: 3.15, curveX: 0.12, flightSeconds: 0.84, keeperAction: 'left-high' },
];

export const missShotProfiles: readonly ShotProfile[] = [
  { id: 'save-right-low', outcome: 'save', target: { x: 1.9, y: 0.88, z: -9.55 }, apexY: 2.3, curveX: 0.18, flightSeconds: 0.82, keeperAction: 'right-low' },
  { id: 'post-left', outcome: 'post', target: { x: -3.66, y: 1.0, z: -10.05 }, apexY: 2.55, curveX: -0.22, flightSeconds: 0.86, keeperAction: 'left-low' },
  { id: 'crossbar-center', outcome: 'crossbar', target: { x: 0.5, y: 2.46, z: -10.05 }, apexY: 3.72, curveX: 0.1, flightSeconds: 0.9, keeperAction: 'right-high' },
  { id: 'wide-right', outcome: 'wide', target: { x: 4.15, y: 1.15, z: -10.15 }, apexY: 2.72, curveX: 0.34, flightSeconds: 0.86, keeperAction: 'right-low' },
  { id: 'high-left', outcome: 'high', target: { x: -1.45, y: 3.35, z: -10.1 }, apexY: 4.32, curveX: -0.26, flightSeconds: 0.92, keeperAction: 'left-high' },
  { id: 'save-left-high', outcome: 'save', target: { x: -1.85, y: 1.78, z: -9.55 }, apexY: 3.25, curveX: -0.2, flightSeconds: 0.88, keeperAction: 'left-high' },
];

export function selectShotProfile(correct: boolean, sequence: number): ShotProfile {
  const pool = correct ? goalShotProfiles : missShotProfiles;
  return pool[Math.abs(Math.trunc(sequence)) % pool.length];
}

/** Yanlış cevabın otomatik şutu: `random` [0,1) ile kurtarış/direk/dışarı profillerinden biri, bir öncekinden farklı. */
export function selectRandomMissProfile(random: number, previousId?: string): ShotProfile {
  let index = Math.min(missShotProfiles.length - 1, Math.max(0, Math.floor(random * missShotProfiles.length)));
  if (missShotProfiles[index].id === previousId) index = (index + 1) % missShotProfiles.length;
  return missShotProfiles[index];
}
